import { atom } from 'jotai';

/** Sections ouvertes par défaut à l’ouverture du panneau filtres. */
export const DEFAULT_FILTER_SIDEBAR_ACCORDION_VALUES: string[] = [
  'listPrice',
  'stockQuantity',
];

/**
 * Valeur initiale du panneau accordéon (réappliquée à chaque montage du FilterSidebar).
 */
export const filterSidebarAccordionDefaultValueState = atom<string[]>(
  DEFAULT_FILTER_SIDEBAR_ACCORDION_VALUES
);
